module.exports = __webpack_public_path__ + "static/media/caishens-gold.d0b43fa6.gif";